import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { VerticalDotsIcon } from '../../../utils/icons';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { DownAngleV2 } from '../../SocialFeedsV2/styles';

/* ---------------- Styled Components ---------------- */

const Wrapper = styled.div`
  width: 100%;
`;

const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1.5fr 40px;
  gap: 16px;

  margin: 20px 0;
  padding: 10px 12px;

  border-radius: 6px;
  border: 1px solid #efefef;
  background: #fefefe;

  color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
`;

const ListRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1.5fr 40px;
  gap: 16px;

  align-items: center;

  margin: 20px 0;
  padding: 16px 20px;

  border-radius: 6px;
  border: 1px solid #efefef;
  background: #fff;
`;

const DocCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const DocIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: #eef2ff;
  display: flex;
  align-items: center;
  justify-content: center;
  ${'' /* font-size: 14px; */}
  ${'' /* font-weight: 600; */}
  ${'' /* color: #4f46e5; */}

  color: #184A61;
font-family: Lato;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
`;

const DocName = styled.span`
color:  #184A61;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px; 
`;

const TextCell = styled.div`
color: #184A61;
${'' /* text-align: right; */}

font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
`;

const MenuWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

/* ---------------- Component ---------------- */

const DocumentsListView = ({
  documents = [],
  onEdit,
  onDownload,
  onDelete,
}) => {

  useEffect(()=>{},[])
  return (
    <Wrapper>
      {/* Header */}
      <HeaderRow>
        <div>Doc Name</div>
        <div>Downloads</div>
        <div>Uploaded By</div>
        <div>Last Updated</div>
        <div />
      </HeaderRow>

      {/* List */}
      {documents.map((doc) => (
        <ListRow key={doc.id}>
          <DocCell>
            <DocIcon>{doc.extension || 'DOC'}</DocIcon>
            <DocName>{doc?.title}</DocName>
          </DocCell>

          <TextCell>{doc.downloads}</TextCell>
          <TextCell>{doc?.uploaded_by}</TextCell>
          <TextCell>{doc?.last_updated}</TextCell>

          {/* Three-dot menu */}
          <MenuWrapper>
            <div className="menu">
              <DownAngleV2  feed padding="0 16px" marginL="-140px">
                <DropdownButton id="deleteTour" title={<VerticalDotsIcon/>} >
                  <Dropdown.Item onClick={()=>onEdit(doc)}>
                    {("Edit")}
                  </Dropdown.Item>
                  <Dropdown.Item onClick={()=>onDownload(doc)}>
                    {("Download")}
                  </Dropdown.Item>
                  <Dropdown.Item onClick={()=>onDelete(doc)}>
                    {("Delete")}
                  </Dropdown.Item>
                </DropdownButton>
              </DownAngleV2>
            </div>
          </MenuWrapper>
        </ListRow>
      ))}
    </Wrapper>
  );
};

/* ---------------- PropTypes ---------------- */

DocumentsListView.propTypes = {
  documents: PropTypes.array.isRequired,
  onEdit: PropTypes.func,
  onDownload: PropTypes.func,
  onDelete: PropTypes.func,
};

export default DocumentsListView;
